import { render } from "./view-login.vue?vue&type=template&id=0b8ea63d&scoped=true"
import script from "./view-login.vue?vue&type=script&lang=js"
export * from "./view-login.vue?vue&type=script&lang=js"

import "./view-login.vue?vue&type=style&index=0&id=0b8ea63d&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8ea63d"]])

export default __exports__